<template>
    <vehicle-query overview />
</template>

<script>
    import VehicleQuery from './components/VehicleQuery'
    export default { name: 'pageAssetVehicleData', components: { VehicleQuery } }
</script>
